import Moment from "moment";

export const columns = {
    name: {
        column: {name: "task", type: "input"},
        name: "Task Name",
        default: true,
        enabled: true,
        readOnly: true,
        width: 500,
        align: "left",
        sorting: "alphabetical"
    },
    status: {
        column: {name: "status", type: "default"},
        name: "Status",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "alphabetical"
    },
    assignee: {
        column: {name: "task_members", type: "array", data: {key: "memberType", value: "assignedTo"}},
        name: "Assignee",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "alphabetical"
    },
    dueDate: {
        column: {name: "dueDate", type: "date"},
        name: "Due Date",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 130,
        align: "center",
        sorting: "chronological"
    },
    daysRemaining: {
        column: {name: "dueDate", type: "date"},
        name: "Days Remaining",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "chronological",
        disableFilters: true
    },
    workstream: {
        column: {name: "workstream", type: "object", data: {key: "workstream"}},
        name: "Workstreams",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 180,
        align: "center",
        sorting: "alphabetical"
    },
    approver: {
        column: {name: "task_members", type: "array", data: {key: "memberType", value: "approver"}},
        name: "Approver",
        default: true,
        enabled: true,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "alphabetical"
    },
    reviewer: {
        column: {name: "task_members", type: "array", data: {key: "memberType", value: "reviewer"}},
        name: "Reviewer",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 130,
        align: "center",
        sorting: "alphabetical"
    },
    followers: {
        column: {name: "task_members", type: "array", data: {key: "memberType", value: "follower"}},
        name: "Followers",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "alphabetical"
    },
    startDate: {
        column: {name: "startDate", type: "date"},
        name: "Start Date",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "chronological"
    },
    applicableFrom: {
        column: {name: "applicableFrom", type: "date"},
        name: "Applicable from",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 180,
        align: "center",
        sorting: "chronological"
    },
    applicableTo: {
        column: {name: "applicableUntil", type: "date"},
        name: "Applicable Until",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 165,
        align: "center",
        sorting: "chronological"
    },
    completionDate: {
        column: {name: "dateCompleted", type: "date"},
        name: "Completion Date",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 180,
        align: "center",
        sorting: "chronological"
    },
    recurrence: {
        column: {name: "periodType", type: "default"},
        name: "Recurrence",
        default: false,
        enabled: false,
        dragDisabled: false,
        width: 150,
        align: "center",
        sorting: "alphabetical"
    }
}

export const categories = [
    {
        id: "today",
        name: "Due Today",
        enabled: false,
        filter: date => Moment(date).isSameOrBefore(Moment().endOf("day")),
        page: 1
    },
    {
        id: "week",
        name: "Due This Week",
        enabled: false,
        filter: date => Moment(date).isAfter(Moment().endOf("day")) && Moment(date).isBefore(Moment().endOf("week")),
        page: 1
    },
    {
        id: "month",
        name: "Due This Month",
        enabled: false,
        filter: date => Moment(date).isAfter(Moment().endOf("week")) && Moment(date).isBefore(Moment().endOf("month")),
        page: 1
    },
    {
        id: "succeedingMonths",
        name: "Succeeding Months",
        enabled: false,
        filter: date => Moment(date).isAfter(Moment().endOf("month")),
        page: 1
    }
]